__turbopack_context__.v({
  "card": "style-module-scss-module__CXN2fW__card",
  "cards": "style-module-scss-module__CXN2fW__cards",
  "textureBg": "style-module-scss-module__CXN2fW__textureBg",
  "title": "style-module-scss-module__CXN2fW__title",
  "wrapper": "style-module-scss-module__CXN2fW__wrapper",
});
